
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyDefault as ObiBuoyDefaultElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-default.js';
 
 
 

 
 export const ObiBuoyDefault = createComponent({
   react: React,
   tagName: 'obi-buoy-default',
   elementClass: ObiBuoyDefaultElement,
   events: {
     
   }
  });
 
 